export { FaqsSearch } from './FaqsSearch';
